import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const Name = styled.div`
  color: #505050;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

const Email = styled.div`
  color: #505050;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const Layout = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-left: 10px;
  z-index: 2;
`;

export const MenuAndMail = () => {
  const { first_name, last_name, email } = useSelector((state) => state.login.loguedAs);
  const first = first_name.charAt(0).toUpperCase() + first_name.slice(1).toLowerCase();
  const last = last_name.charAt(0).toUpperCase() + last_name.slice(1).toLowerCase();

  return (
    <Layout>
      <Name>
        {first} {last}
      </Name>
      <Email>{email}</Email>
    </Layout>
  );
};

export default MenuAndMail;
